/**
 * Created by ssh on 2018/12/19
 * description: axios请求全局配置
 **/
import qs from 'qs';
import axios from 'axios';
import baseConf from './config';
// import * as Sentry from '@sentry/browser';

import { getToken, getUserId } from '@/library/js/auth.js';
import store from '@/store';

// 基地址
const apiBaseUrl = process.env.VUE_APP_APIURL;
const service = axios.create(baseConf);
import Vue from 'vue';

let vm = new Vue();

// 请求拦截
service.interceptors.request.use((config) => {
  // const token = getToken();
  // 这里为了兼容各端没有集成oss，跳转免登录地址的情况
  const token = ssoClient.getCookie() || getToken();
  if (token) { // 判断是否存在token，如果存在的话，则每个http header都加上token
    config.headers.token = token;
    // config.headers.Authorization = store.state.user.Authorization;
  }

  if (config.method === 'post') {
    config.data = qs.stringify(config.data);
  }
  return config;

}, (error) => {
  return Promise.reject(error);
});

// 返回状态判断
service.interceptors.response.use((res) => {
  //判断接口返回类型是否是字符串
  if (typeof (res.data) == 'string') {
    return Promise.resolve(res.data);
  }
  let _data = '';
  switch (res.data.code) {
    case 1:
      _data = res.data;
      break;
    case -1:
      _data = res.data;
      break;
    case 1001:
      _data = res.data.code;
      break;
    case -2:
      _data = res.data.code;
      break;
    default:
      _data = res.data;
      break;
  }
  return _data;
}, (error) => {
  if (!error.response) {
    error.message = '请检查网络是否正常连接';
    // Sentry.captureException(error);
    return Promise.reject(error);
  }
  // 404等问题可以在这里处理
  switch (error.response.status) {
    case 400:
      error.message = '请求错误';
      break;

    case 401:
      error.message = '未授权，请登录';
      break;

    case 402:
      error.message = '登录过期，请重新登录';
      break;

    case 403:
      error.message = '拒绝访问';
      break;

    case 404:
      error.message = `请求地址出错: ${error.response.config.url}`;
      break;

    case 408:
      error.message = '请求超时';
      break;

    case 500:
      error.message = '服务器内部错误';
      break;

    case 501:
      error.message = '服务未实现';
      break;

    case 502:
      error.message = '网关错误';
      break;

    case 503:
      error.message = '服务不可用';
      break;

    case 504:
      error.message = '网关超时';
      break;

    case 505:
      error.message = 'HTTP版本不受支持';
      break;
    default:
      error.message = '服务不可用';
      break;
  }
  if (error.response.status == 401 || error.response.status == 402)
    vm.$Modal.confirm({
      title: '会话超时',
      content: '<p>您当前的会话已超时，请重新登录！</p>',
      onOk: () => {
        ssoClient.logout();
      },
      onCancel: () => {
      }
    });
  // Sentry.captureException(error);
  console.error(error.message);
  return Promise.reject(error);
});

export const POST = (url, params, baseUrl = apiBaseUrl) => {
  if (params !== undefined) {
    params.optUserId = store.getters.userId;
    params.optRealName = store.getters.name;
    if( !params.regionId ) {
      if (!params.noRegionId) {
        params.regionId = store.getters.regionAdminInfo ? JSON.parse(store.getters.regionAdminInfo).id : ''
      }
    }
    params.noRegionId = undefined
  }
  url = baseUrl + url;
  return service({
    method: 'post',
    url,
    data: params
  });
};

export const GET = (url, params, baseUrl = apiBaseUrl) => {
  if (params !== undefined) {
    params.optUserId = store.getters.userId;
    params.optRealName = store.getters.name;
    if( !params.regionId ) {
      if (!params.noRegionId) {
        params.regionId = store.getters.regionAdminInfo ? JSON.parse(store.getters.regionAdminInfo).id : ''
      }
    }
    params.noRegionId = undefined
  }
  url = baseUrl + url;
  return service({
    method: 'get',
    url,
    params
  });
};

export const DELETE = (url, params, baseUrl = apiBaseUrl) => {
  if (params !== undefined) {
    params.optUserId = getUserId();
    params.optRealName = store.getters.name;
  }
  url = baseUrl + url;
  return service({
    method: 'delete',
    url,
    params
  });
};

// 用于mock拦截请求
export function FETCH (url, params) {
  // return new Promise((resolve, reject) => {
  //     axios.post(url, params)
  //         .then(response => {
  //             resolve(response.data);
  //         })
  //         .catch((error) => {
  //             reject(error);
  //         })
  // })
  return axios.post(url, qs.stringify(params)).then(res => res.data);
}
export const JsonGet = (url) => {
  let result = new Promise((resolve, reject) => {
    return axios.get(url).then((res) => {
      if (res.status == 200) {
        resolve({ code: 1, msg: '请求成功!', data: res.data })
      } else {
        reject({ code: 0, msg: '请求失败!', data: [] })
      }
    }).catch(() => {
      reject({ code: 0, msg: '请求失败!', data: [] })
    })
  })
  return result
};
